import { PreloadableRouteObject, TFileToRouteMap } from '~/app/models'
import { getRoutesFromMap } from '~/app/utils/lazy'
import AdminPortalPartnerThemeOutlet from '~/features/admin/components/adminPortalPartnerThemeOutlet'
import { EAdminPortalClientPath } from '~/models/api'

const createUpdatePartnerImport = () =>
  import('~/features/admin/components/partner/createUpdate')

const adminPortalRoutesFileToRouteMap: TFileToRouteMap = {
  adminHomePage: {
    path: EAdminPortalClientPath.admin,
    getImportPromise: () => import('~/pages/admin/adminHomePage'),
  },
  adminOrgsAndUsersPage: {
    path: EAdminPortalClientPath.orgsAndUsers,
    getImportPromise: () => import('~/pages/admin/adminOrgsAndUsersPage'),
  },
  adminPartnerManagementPage: {
    path: EAdminPortalClientPath.partnerManagement,
    getImportPromise: () => import('~/pages/admin/adminPartnerManagementPage'),
  },
  adminPartnerManagementCreate: {
    path: EAdminPortalClientPath.partnerCreate,
    getImportPromise: createUpdatePartnerImport,
  },
  adminPartnerManagementEdit: {
    path: EAdminPortalClientPath.partnerEdit,
    getImportPromise: createUpdatePartnerImport,
  },
  adminUsageReportsPage: {
    path: EAdminPortalClientPath.usageReports,
    getImportPromise: () => import('~/pages/admin/adminUsageReportsPage'),
  },
  adminTemplatesPage: {
    path: EAdminPortalClientPath.serviceTemplates,
    getImportPromise: () => import('~/pages/admin/adminTemplatesPage'),
  },

  adminCampaignTemplatesPage: {
    path: EAdminPortalClientPath.campaignTemplates,
    getImportPromise: () => import('~/pages/admin/adminCampaignTemplatesPage'),
  },
  adminCampaignTemplatesCreate: {
    path: EAdminPortalClientPath.campaignTemplatesCreateEdit,
    getImportPromise: () =>
      import('~/pages/admin/adminCampaignTemplateCreatePage'),
  },

  adminCampaignTemplatesVersionEdit: {
    path: EAdminPortalClientPath.campaignTemplateVersionEdit,
    getImportPromise: () =>
      import('~/pages/admin/adminCampaignTemplateCreatePage'),
  },

  adminCampaignTemplatesVersionsPage: {
    path: EAdminPortalClientPath.campaignTemplateVersions,
    getImportPromise: () =>
      import('~/pages/admin/adminCampaignTemplateVersionsPage'),
  },

  adminUserPage: {
    path: EAdminPortalClientPath.user,
    getImportPromise: () => import('~/pages/admin/adminUserPage'),
  },
  adminOrganizationPage: {
    path: EAdminPortalClientPath.organization,
    getImportPromise: () => import('~/pages/admin/adminOrganizationPage'),
  },
  adminPromptMetadataPage: {
    path: EAdminPortalClientPath.promptMetadata,
    getImportPromise: () => import('~/pages/admin/adminPromptMetadataPage'),
  },
  adminPhoneNumbersPage: {
    path: EAdminPortalClientPath.phoneNumbers,
    getImportPromise: () => import('~/pages/admin/adminPhoneNumbersPage'),
  },
  adminPlanMetadataPage: {
    path: EAdminPortalClientPath.planMetadata,
    getImportPromise: () => import('~/pages/admin/adminPlanMetadataPage'),
  },
  adminVoiceTemplatesPage: {
    path: EAdminPortalClientPath.voiceTemplates,
    getImportPromise: () => import('~/pages/admin/adminVoiceTemplatesPage'),
  },
  adminManageAdminUsersPage: {
    path: EAdminPortalClientPath.manageAdminUsers,
    getImportPromise: () => import('~/pages/admin/adminManageAdminUsersPage'),
  },
}

const adminPortalRoutesWithPartnerTheme: TFileToRouteMap = {
  adminPortalGeneralSettingsPage: {
    path: EAdminPortalClientPath.portalGeneralSettings,
    getImportPromise: () =>
      import('~/pages/admin/adminPortalGeneralSettingsPage'),
  },
  adminPortalBrandingPage: {
    path: EAdminPortalClientPath.portalBranding,
    getImportPromise: () => import('~/pages/admin/adminPortalBrandingPage'),
  },
}

const adminPortalRoutes: PreloadableRouteObject[] = getRoutesFromMap(
  adminPortalRoutesFileToRouteMap,
).concat({
  element: <AdminPortalPartnerThemeOutlet />,
  children: getRoutesFromMap(adminPortalRoutesWithPartnerTheme),
} as unknown as PreloadableRouteObject)

export default adminPortalRoutes
